import { ConfigClientView } from './Client';
import { ConfigOverviewView as ClientOverview } from './Overview';
import  CreateUpdateClient  from './CreateUpdate';

export { ClientOverview , CreateUpdateClient };
export default ConfigClientView;